<span id="type-icon">
    <svg class="icon">
        <use [attr.href]="iconMap[iconDetail?.iconType]"></use>
    </svg>
    <span [innerHTML]="value | boldText: searchFilter : minSearchLength" class="textContent"></span>
</span>